<template>
  <div class="cause-contain">
      <div class="img">
        <img src="../../../assets/appraise/nodata.png"/>
      </div>
      <div class="title">{{noData.title}}</div>
  </div>
</template>

<script>
    export default {
        name: 'causeDeduction',
        props: {
            'id': String,
            'noData': Object
        },
        data () {
            return {

            }
        },
        mounted () {

        }
    }
</script>

<style lang="less" scoped>
.cause-contain{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .img{
    width: 74px;
    height: 62px;
    margin: 0 auto;
    margin-bottom: 24px;
    img{
      width: 100%;
    }
  }
  .title{
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:12px;
  }
}
</style>
